import outclick from './outclick';
import debounce from './debounce';
import type { PluginFunction } from 'vue';
import dateFormat from './dateFormat';
import zeroFill from './zeroFill';
import numFixed from './numFixed';

const directives: any = {
    outclick,
    debounce,
};

export default {
    install(Vue) {
        Object.keys(directives).forEach((name: string) => {
            Vue.directive(name, directives[name]);
        });
        Vue.filter('dateFormat', dateFormat);
        Vue.filter('zeroFill', zeroFill);
        Vue.filter('numFixed', numFixed);
    },
} as { install: PluginFunction<any> };

